export function setCaretPosition(x, y) {
  // Figure out what select range would of occured if the mouse actually clicked
  // this element

  let node = null;
  let offset = null;

  // Chrome / Safari
  if (document.caretRangeFromPoint) {
    const caretRangeFromPoint = document.caretRangeFromPoint(x, y);
    node = caretRangeFromPoint && caretRangeFromPoint.startContainer;
    offset = caretRangeFromPoint && caretRangeFromPoint.startOffset;
    // Firefox
  } else {
    // This is a TS issue - document should have an optional `caretPositionFromPoint` property
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/caretPositionFromPoint
    const caretPositionFromPoint = document.caretPositionFromPoint(x, y);
    node = caretPositionFromPoint && caretPositionFromPoint.offsetNode;
    offset = caretPositionFromPoint && caretPositionFromPoint.offset;
  }
  if (!node || !offset) {
    return;
  }
  const newRange = document.createRange();
  newRange.setStart(node, offset);
  newRange.setEnd(node, offset);

  // Set the cursor position
  const sel = window.getSelection();
  if (sel) {
    sel.removeAllRanges();
    sel.addRange(newRange);
  }
}